import "./featuredInfo.css";
import { FiArrowDown } from "react-icons/all";
import { getProducts } from "../../Data/Products";
import React,{ useState, useEffect } from "react";
import { getOrders } from "../../Data/Orders";

function FeaturedInfo() {
  const [Allproducts, setAllProducts] = useState([]);
  const [orderItems, setOrderItems] = useState([]);

  useEffect(() => {
    const fetchProducts = async () => {
      const ProductCollection = await getProducts();
      setAllProducts(
        ProductCollection.docs.map((doc) => {
          return {
            data: doc.data(),
          };
        })
      );
    };
    return fetchProducts();
  }, [Allproducts]);

  useEffect(() => {
    const fetchOrders = async () => {
      const OrdersCollect = await getOrders();
      setOrderItems(
        OrdersCollect.docs.map((doc) => {
          return {
            data: doc.data(),
            id: doc.id,
          };
        })
      );
    };

    return fetchOrders();
  }, [orderItems]);

  return (
    <div className="featured">
      <div className="featuredItem">
        <span className="featuredTitle">Total Products</span>
        <div className="featuredMoneyContainer">
          <span
            className="featuredMoney"
            style={{ color: "coral", fontSize: "50px" }}
          >
            {Allproducts.length}
          </span>
        </div>
      </div>
      <div className="featuredItem">
        <span className="featuredTitle">Orders</span>
        <div className="featuredMoneyContainer">
          <span
            className="featuredMoney"
            style={{ color: "cyan", fontSize: "50px" }}
          >
            {orderItems.length}
          </span>
        </div>
      </div>
    </div>
  );
}

export default FeaturedInfo;
